// ** Redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";
import { getUserEmail } from "../global-user/actions/get-user-email.action";

// ############################################################

// Async thunks
export const postSupportMessage = createAsyncThunk(
	"pages/contact/postSupportMessage",
	createApiCall(
		async (
			{
				token = false,
				email = "",
				message = "",
				isAndroid = false,
				version = "web",
				phoneBrand = "web",
				appVersion = "web",
				file = null,
			},
			client
		) => {
			const finalMessage = message;
			const data = {
				email,
				message: finalMessage,
				isAndroid,
				version,
				phoneBrand,
				appVersion,
			};
			const formData = new FormData();
			formData.append("data", JSON.stringify(data));
			if (token) {
				formData.append("token", token);
			}
			if (file) {
				formData.append("file", file);
			}
			if (!token) {
				return await client.post(
					"/datezone/support/unauthorized",
					formData
				);
			} else if (file) {
				const {
					data: { token: _uploadToken },
				} = await client.get("/system/token");
				formData.append("token", _uploadToken);
				return await client.post("/datezone/support", formData);
			} else {
				return await client.post("/datezone/support", formData);
			}
		}
	)
);

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	success: false,
	error: false,
};

// ############################################################

// Slice
const servicePageContactSlice = createSlice({
	name: "service-pages/contact",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// postSupportMessage
			.addCase(postSupportMessage.pending, (state) => {
				state.loading = true;
				state.success = false;
				state.error = false;
				state.loaded = false;
			})
			.addCase(postSupportMessage.fulfilled, (state) => {
				state.loading = false;
				state.success = true;
				state.loaded = true;
			})
			.addCase(postSupportMessage.rejected, (state) => {
				state.loading = false;
				state.success = false;
				state.error = true;
				state.loaded = true;
			})
			.addCase(getUserEmail.pending, (state) => {
				state.loading = true;
			})
			.addCase(getUserEmail.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(getUserEmail.rejected, (state) => {
				state.loading = false;
			});
	},
});

// ############################################################

export default servicePageContactSlice.reducer;

// ############################################################
